import c from 'classnames';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';
import { dividerStyles } from './styles';
import { DividerTypes } from './types';

const lightDividerSpanAttrs = {
  style: `margin-bottom: 0.7rem;`,
  class: 'w-4 h-4 rounded-full bg-border-dark inline-block me-8 mt-6',
};

export default class HorizontalRule extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        type: {
          default: DividerTypes.Regular,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'div.divider',
          getAttrs: (element) => {
            return { type: (element as HTMLElement).dataset.type };
          },
        },
      ],
      toDOM: (node) => {
        const { type = DividerTypes.Regular } = node.attrs;
        if (type === DividerTypes.Bold) {
          return [
            'div',
            { class: c('my-36 divider flex flex-col', dividerStyles), 'data-type': type },
            [
              'hr',
              { class: 'border border-focus', style: `margin-top:0.8rem; margin-bottom:0.7rem;` },
            ],
          ];
        } else if (type === DividerTypes.Light) {
          return [
            'div',
            { class: c('my-36 divider flex justify-center', dividerStyles), 'data-type': type },
            ['span', lightDividerSpanAttrs],
            ['span', lightDividerSpanAttrs],
            ['span', lightDividerSpanAttrs],
          ];
        }

        return [
          'div',
          { class: c('my-36 divider flex flex-col', dividerStyles), 'data-type': type },
          ['hr', { class: 'my-8 border-divider' }],
        ];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  plugins = plugins;
}
